var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from "react";
import { useSelector } from "react-redux";
export var useUserInfo = function () {
    var user = useSelector(function (state) { return state.user.info; });
    var token = useSelector(function (state) { return state.user.token; });
    var userInfo = useMemo(function () {
        var _a, _b;
        if (user.name) {
            var firstName = (_a = user === null || user === void 0 ? void 0 : user.name) === null || _a === void 0 ? void 0 : _a.split(" ")[0];
            var lastName = (_b = user === null || user === void 0 ? void 0 : user.name) === null || _b === void 0 ? void 0 : _b.split(" ")[1];
            return __assign(__assign({}, user), { organisationId: user.realm, token: token, firstName: firstName, lastName: lastName });
        }
        return {};
    }, [user.name, token]);
    return userInfo;
};
